import React from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import { Tooltip } from 'react-tooltip';
import { CircularMetricProps } from '../types';

export const CircularMetric: React.FC<CircularMetricProps> = ({
    label, value, color, trailColor, icon, showPercentage = false, isLoading = false, tooltip,
}) => {
    const tooltipId = `stat-card-${label.replace(/\s+/g, '-').toLowerCase()}`;
    const pathColor = isLoading ? '#c8d6e5' : color;
    const trail = isLoading ? '#dfe6e9' : (trailColor ?? '#e8e8f0');
    const iconBg = isLoading ? '#dfe6e9' : `${color}22`;
    const iconColor = isLoading ? '#b2bec3' : color;

    const getIconClass = () => {
        if (isLoading) return 'pi pi-minus';
        if (icon === 'check') return 'pi pi-check';
        return 'pi pi-exclamation-circle';
    };

    const progressValue = (): number => {
        if (isLoading) return 0;
        if (typeof value === 'number') return value;
        return 0;
    };

    const displayValue = () => {
        if (value == null) return '--';
        if (showPercentage && value) return `${value}%`;
        return `${value}`;
    };

    return (
        <div className="cap-circular-metric">
            <div className="cap-circular-metric__chart">
                <CircularProgressbar
                    value={progressValue()}
                    strokeWidth={15}
                    styles={buildStyles({
                        pathColor,
                        trailColor: trail,
                        strokeLinecap: 'round',
                    })}
                />
                <div
                    className="cap-circular-metric__icon-wrapper"
                    style={{ backgroundColor: iconBg }}
                >
                    <i
                        className={getIconClass()}
                        style={{ color: iconColor, fontSize: '20px' }}
                    />
                </div>
            </div>
            <div className="cap-circular-metric__info">
                <div className="cap-stat-card__label-row">
                <span className="cap-stat-card__label">{label}</span>
                {Tooltip && (
                    <>
                        <span
                            className="cap-stat-card__tooltip-icon"
                            data-tooltip-id={tooltipId}
                        >
                            ?
                        </span>
                        <Tooltip
                            id={tooltipId}
                            className="cap-stat-card__tooltip"
                            place="top"
                        >
                            <div style={{ maxWidth: '250px', fontSize: '12px', lineHeight: '1.5' }}>
                                {tooltip}
                            </div>
                        </Tooltip>
                    </>
                )}
            </div>
                <hr className="cap-circular-metric__divider" />
                {isLoading ? (
                    <span className="cap-circular-metric__loading-text">
                        Some data may take some time to update
                    </span>
                ) : (
                    <span className="cap-circular-metric__value" style={{ color }}>
                        {displayValue()}
                    </span>
                )}
            </div>
        </div>
    );
};